// extracted by mini-css-extract-plugin
module.exports = {"instructions":"ResetPassword_instructions__2pa5v","inputField":"ResetPassword_inputField__2KkCl","errorMessage":"ResetPassword_errorMessage__1In38"};